/**
 * Represents a step within a Pendo Guide.
 */
export interface PendoGuideStep {
  id: string;
  title: string;
}

/**
 * Represents a Pendo Guide object.
 */
export interface PendoGuide {
  id: string;
  name: string;
  published: boolean;
  steps?: PendoGuideStep[];
}

interface PendoAPI {
  findGuideByName: (guideName: string) => PendoGuide | undefined;
  findGuideById: (guideId: string) => PendoGuide | undefined;
  showGuideByName: (guideName: string) => void;
  showGuideById: (guideId: string) => boolean;
  onGuideDismissed: () => void;
  dismissGuide: () => void;
  track: (eventName: string, metadata?: Record<string, unknown>) => void;
  pageLoad?: (options?: { url?: string }) => void;
}

/**
 * Extends the global `window` object with Pendo.
 */
declare global {
  interface Window {
    pendo?: PendoAPI;
  }
}

/**
 * Getter function for accessing Pendo API safely.
 * Ensures that `window.pendo` is always accessed at runtime,
 * even if Pendo initializes after this module is loaded.
 */
const getPendoAPI = (): PendoAPI | undefined => {
  return window.pendo;
};

export default getPendoAPI;
